<template>
    <div ref="container" class="container">

        <header class='text-center'>
            <div class="header-icon header-icon--profile"></div>
            <!-- <img src="img/egl/patient-standard2.svg" alt="" class="header-icon"> -->
            <!-- <img v-else src="img/icon-login.svg" alt="" class="header-icon"> -->
            <h1 class="h2">{{ $t('translations.i_am_asking_as_a')}} ...</h1>
        </header>

        <div class=''>

            <div class="list-message_item">
                <div v-if='$root.user' class="message-neutral">
                    <button v-on:click='goNextPatient()' class="card-button w-100 mb-2" title="for patient">
                        <div class="card-icon"><img src="/img/egl/icon-placeholder.svg" alt="link icon"></div>
                        <div><h2>{{ $t('translations.patient') | capitalise }}</h2></div>
                    </button>
                    <!-- <button v-else v-on:click='goNextPatient()' class="btn btn-round btn-block btn-primary">{{ $t('translations.patient') | capitalise }}</button> -->
                    
                    <button v-on:click='goNextProxy()' class="card-button w-100">
                        <div class="card-icon"><img src="/img/egl/icon-placeholder.svg" alt="link icon" title="for carer"></div>
                        <div><h2>{{ $t('translations.parent_or_carer')}}</h2></div>
                    </button>
                    <!-- <button v-else v-on:click='goNextProxy()' class="btn btn-round btn-block btn-primary">{{ $t('translations.parent_or_carer')}}</button> -->
                </div>
            </div>

        </div>
    </div><!--ref:container-->


</template>

<script>
var moment = require('moment');
export default {
    props: [
    ],
    data: function(){
        return {

        }
    },
    mounted() {

    },
    methods: {
        initForm(action_id) {
            var data = {
                action_id: action_id,
            }
            axios.post(this.$root.apiBase + "/formsubmissions/existing_or_new_from_custom_action", data).then((res) => {
                app.$root.$router.push({path: "/form-submission/" + res.data.id});
                
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create");
            });
            // axios.post(this.$root.apiBase + "/formsubmissions", data).then((res) => {
            //     app.$root.$router.push({path: "/form-submission/" + res.data.id});
                
            // }).catch((error) => {
            //     this.setLoading(false);
            //     this.handleError(error, "create");
            // });
        },
        goNextPatient() {
            if(this.$root.user.gender == null || this.$root.user.dob == null || this.$root.user.provider.site_id == null) {
                this.$router.push({name: "RegisterPatient", params: {action: this.$route.params.action}});
            }
            else if(this.$route.params.action_id) {
                this.initForm(this.$route.params.action_id);
            }
            else {
                this.$router.push({name: "selectAction", params: {user_id: this.$root.user.id}});
            }
        },
        goNextProxy() {
            var name = this.$root.user.carees != null ? 'SelectCaree' : 'RegisterProxy';
            
            this.$router.push({name: name, params: {action: this.$route.params.action, action_id: this.$route.params.action_id}});
        },
        
    }
}
</script>
